module.exports = __webpack_public_path__ + "static/img/1_0014.8de0383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0014.jpg
// module id = +tuG
// module chunks = 0